import type { ReactNode } from 'react';
import type { TranslationDictionary } from '@enmon-monorepo/i18n';
import { SharedLanguageProvider } from '@enmon-monorepo/i18n/react';
import type { Locale } from '@enmon/commons';
import { useLocaleState } from '@/containers/LanguageProvider/hooks/useLocaleState';

interface LanguageProviderProps {
  messages: Record<Locale, TranslationDictionary>;
  children: ReactNode;
}

export const LanguageProvider = ({ messages, children }: LanguageProviderProps) => {
  const { locale } = useLocaleState();

  return (
    <SharedLanguageProvider locale={locale} messages={messages[locale]}>
      {children}
    </SharedLanguageProvider>
  );
};
